"use client";
import * as React from "react";
const SvgArrowForwardRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.03 9.02H12.5l-5.01 5.01c-.4.4-.4 1.06 0 1.46s1.04.4 1.44 0l6.77-6.77c.4-.4.4-1.04 0-1.44L8.94.5A1.02 1.02 0 1 0 7.5 1.95l5 5.02H1.03A1.03 1.03 0 0 0 0 8a1.03 1.03 0 0 0 1.03 1.02" }));
export {
  SvgArrowForwardRound as default
};
